import { defineMessages } from 'react-intl';

/** i18n for YouTube connect alternatives shown in the multi-method dialog. */
export const youtubeConnectMessages = defineMessages({
  basicName: {
    id: 'socialExport.youtube.connect.basicName',
    defaultMessage: 'Modo básico',
  },
  basicDescription: {
    id: 'socialExport.youtube.connect.basicDescription',
    defaultMessage: 'Publicar videos sin gestionar listas ni borrar',
  },
  basicPermissions: {
    id: 'socialExport.youtube.connect.basicPermissions',
    defaultMessage: 'Solo subir videos',
  },
  advancedName: {
    id: 'socialExport.youtube.connect.advancedName',
    defaultMessage: 'Modo avanzado',
  },
  advancedDescription: {
    id: 'socialExport.youtube.connect.advancedDescription',
    defaultMessage: 'Gestionar listas de reproducción y eliminar videos',
  },
  advancedPermissions: {
    id: 'socialExport.youtube.connect.advancedPermissions',
    defaultMessage: 'Subir videos, añadir a listas de reproducción y borrar videos',
  },
});
